/* WaveCanvasとOrbCanvasがbodyカーソルを取り合わないよう参照カウントで共有する */
let grabCount = 0;

/* 「つかめる領域」への出入り。重なり領域では両方がカウントするので
   片方の領域を出てももう片方が残っていれば grab 表示が維持される */
export function setGrab(on) {
  grabCount = Math.max(0, grabCount + (on ? 1 : -1));
  if (document.body.style.cursor !== "grabbing")
    document.body.style.cursor = grabCount > 0 ? "grab" : "";
}

/* ドラッグ中の grabbing 表示。離したら grab 領域内かどうかで復元 */
export function setGrabbing(on) {
  document.body.style.cursor = on ? "grabbing" : grabCount > 0 ? "grab" : "";
}
